import { render, staticRenderFns } from "./AcceptCguDialog.vue?vue&type=template&id=1e106b85&"
import script from "./AcceptCguDialog.vue?vue&type=script&lang=ts&"
export * from "./AcceptCguDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports